import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning-yellow",
  "use": "icon-warning-yellow-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-warning-yellow\"><path d=\"M7 0C3.15 0 0 3.15 0 7s3.15 7 7 7 7-3.15 7-7-3.15-7-7-7Zm-.55 3h1.1v5.5h-1.1V3ZM7 11.5c-.4 0-.75-.35-.75-.75S6.6 10 7 10s.75.35.75.75-.35.75-.75.75Z\" fill=\"#FFB600\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol